import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsIngressComponent } from './simple-icons-ingress.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsIngressComponent ],
    exports:      [ SimpleIconsIngressComponent ],
    bootstrap:    []
})
export class SimpleIconsIngressModule {}
